/**
 * @generated SignedSource<<f044573e2242b448613b0f9ebd46dad3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RichTextCell_issue$data = {
  readonly canBeExported?: boolean | null | undefined;
  readonly " $fragmentType": "RichTextCell_issue";
};
export type RichTextCell_issue$key = {
  readonly " $data"?: RichTextCell_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"RichTextCell_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "RichTextCell_issue",
  "selections": [
    {
      "condition": "isDensityFull",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canBeExported"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "738c991e06df9ecde7051ba2a1a384c0";

export default node;
